import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconImport: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconImport"><Path d="M2 4V6H7C9.20914 6 11 7.79086 11 10V12.5858L8.25 9.83579L6.83579 11.25L12 16.4142L17.1642 11.25L15.75 9.83579L13 12.5858V10C13 6.68629 10.3137 4 7 4H2Z" fill="currentColor"/><Path d="M15 4V6H20V18H4V8H2V20H22V4H15Z" fill="currentColor"/></CentralIconBase>;
});

export default IconImport;
